import styled from 'styled-components';

export const StyledForm = styled.form`
  width: 100%;
  max-width: ${({ theme }) => theme.dimensions.searchForm.width};
  z-index: ${({ theme }) => theme.zindexes.search};
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  overflow: auto;
`;
